module.exports = __webpack_public_path__ + "src/assets/images/login/customers/Yarraranges_logo.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/login/customers/Yarraranges_logo.jpg
// module id = 2316
// module chunks = 4